module.exports = __webpack_public_path__ + "static/media/LogoBronze.2ffd470c.png";